import 'owl.carousel';

export default function() {
    $(".herald-slider").each(function () {
        var controls = $(this).closest('.herald-module').find('.herald-slider-controls');
        var module_columns = $(this).closest('.herald-module').attr('data-col');
        var layout_columns = controls.attr('data-col');
        var slider_items = module_columns / layout_columns;
        var autoplay_time = parseInt(controls.attr('data-autoplay')) * 1000;
        var autoplay = autoplay_time ? true : false;
        $(this).owlCarousel({
            rtl: herald_js_settings.rtl_mode === "true",
            loop: true,
            autoHeight: false,
            autoWidth: false,
            items: slider_items,
            margin: 40,
            nav: true,
            center: false,
            fluidSpeed: 100,
            autoplay: autoplay,
            autoplayHoverPause: true,
            autoplayTimeout: autoplay_time,
            navContainer: controls,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    margin: 20,
                    items: layout_columns <= 2 ? 2 : 1
                },
                768: {
                    margin: 30
                },
                1480: {
                    margin: 40
                }
            }
        });
    });
}
